import React from 'react';

import {labels} from '../../../../../util/utils';
import {contactListColumnIds, dashboardViews} from '../../../../../util/uiconstants';

import DashBoardCount from '../../DashboardCount';

const DashboardColumn = ({item}) => (
	<DashBoardCount
		count={item?.dashboard?.filter((d) => Object.values(dashboardViews).includes(d)).length}
		condition={item?.dashboard?.filter((d) => Object.values(dashboardViews).includes(d)).some((x) => x)}
		text={labels.dashboardViews}
	/>
);

export const config = (labels) => ({
	id: contactListColumnIds.dashboard,
	label: labels.columnDashboard,
	propName: 'dashboard',
	width: 'var(--px-200)',
	sortBy: [{propName: 'dashboard', sortByLength: true}, 'name', 'lastName'],
	customCell: (item) => {
		const props = {item};
		return <DashboardColumn {...props} />;
	}
});
